import { Box, styled } from '@mui/material';

const RightSide = styled(Box)`
  width: 298px;
  padding-left: 20px;
  flex: none;
  padding-top: 20px;
`;

export default RightSide;
